import React from "react";
import { useNavigate } from "react-router-dom";

const CallbackSent = () => {
  const navigate = useNavigate();

  return (
    <div style={{ width: 500, margin: "0 auto" }} className="mt-4 text-center">
      <h2 className="mb-3">Thank You</h2>
      <p style={{ color: "gray" }}>
        Your details have been received. A member of the Lendle team will be in
        touch to discuss your bespoke lease extension calculation.
      </p>
      <button onClick={() => navigate("/dashboard/search")} className="mt-2">
        Back to Search
      </button>
    </div>
  );
};

export default CallbackSent;
